<script setup lang="ts">
defineProps<{ menuItems: NavMenuItem[] }>();
</script>

<template>
  <nav id="site-header-top" class="bg-muted py-1.5 links:link-opacity" :aria-label="__('Top menu navigation', 'egalite')">
    <ul class="container flex justify-end items-center gap-3">
      <li v-for="item in menuItems" :key="item.id" :class="item.class">
        <a :href="item.url" :title="item.description || item.title" :target="item.target || undefined" :rel="item.target === '_blank' ? 'noopener noreferrer' : undefined" :aria-current="item.current ? 'page' : undefined">
          {{ item.title }}
        </a>
      </li>
    </ul>
  </nav>
</template>
